import Icon from "@expo/vector-icons/MaterialCommunityIcons";
import {
	Button as RNButton,
	type ButtonProps as RNButtonProps,
} from "react-native-paper";
import type { IconType } from "../types";
import { useAppTheme } from "../useAppTheme";

type props = {
	label?: string;
	asset?: "none" | "startIcon" | "endIcon";
};

export type ButtonProps = RNButtonProps & props;

const Button = ({ labelStyle, label, asset, icon, ...props }: ButtonProps) => {
	const theme = useAppTheme();

	return (
		<RNButton
			{...props}
			labelStyle={[theme.componentOverrides?.button?.labelStyle, labelStyle]}
			style={[
				props.style,
				props.mode === "elevated" && {
					backgroundColor: theme.colors.surfaceContainerLow,
				},
			]}
			contentStyle={[
				props.contentStyle,
				{
					flexDirection: asset === "endIcon" ? "row-reverse" : "row",
				},
			]}
			icon={
				icon
					? (props) => <Icon name={icon as IconType} {...props} />
					: undefined
			}
		>
			{label ?? props.children}
		</RNButton>
	);
};
export default Button;
